export const routes = {
    index: '/',
    success_stories: '/success-stories',
    share_story: '/share',
    abs_path_share_story: '/success-stories/share',
    group_site: 'https://badoo.com/',
    privacy: '/privacy',
    candidate_cookie_policy: '/candidate-privacy-policy',
    terms: '/terms',
    cookie_policy: '/cookie-policy',
    // exception due to id in href.
    // @todo - refactor link component to fix this case in future
    cookie_policy_functional_anchor: 'https://bumble.com/cookie-policy#functional',
    gender_pay: 'https://gender-pay-gap.service.gov.uk/Employer/MADP5z7b/2020',
    about: '/about',
    bumble_about: '/about',
    badoo_about: 'https://badoo.com/about',
    life: '/life',
    teams: '/teams',
    teams_engineering: '/teams/engineering',
    teams_marketing: '/teams/marketing',
    teams_creative_design: '/teams/creative-and-design',
    benefits: '/benefits',
    benefits_austin: '/benefits/austin',
    benefits_london: '/benefits/london',
    benefits_moscow: '/benefits/moscow',
    benefits_barcelona: '/benefits/barcelona',
    open_roles: '/open-roles',
};

import { Theme } from 'ui/themes';
import { Post } from 'interfaces/microsite-cms';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';

export const SUPPORTED_LANGUAGE_LIST: Array<{ code: SupportedLanguage; name: string }> = [
    {
        code: 'en',
        name: 'English (United Kingdom)',
    },
];

export const SOCIAL_IMAGE_FALLBACK = 'https://bumbcdn.com/bumble-fb-share.png?v2';

// These categories should be in English
export const postsCategoriesForMainPage = {
    Love: 'Love',
    Friendship: 'Friendship',
    Career: 'Career',
} as const;

export const postsCategories = {
    ...postsCategoriesForMainPage,
    HowTo: 'How-To',
    Wellness: 'Wellness',
    Events: 'Events',
} as const;

export type Categories = (typeof postsCategories)[keyof typeof postsCategories];

const MainPage = {
    id: 'mainpage',
    title: 'Bumble Buzz',
    url: '/the-buzz',
    theme: Theme.NONE,
    category: null,
};

export const logoUrl = MainPage.url;

export const actionIosAppDownloadUrl =
    'https://app.appsflyer.com/id930441707?pid=blog_self&amp;c=blog_index';

export const actionAndroidAppDownloadUrl =
    'https://app.appsflyer.com/com.bumble.app?pid=blog_self&amp;c=blog_index';

export const FB_APP_ID = '428250913904849';
export const GOOGLE_ANALYTICS_ACCOUNT = 'G-1MSEYK9Z8R';

export const PID = 'blog_self';
export const IOS_URL = `https://app.appsflyer.com/id930441707`;
export const ANDROID_URL = `https://app.appsflyer.com/com.bumble.app`;

export function setAppsFlayerURL(base: string, pid: string, campaign: string) {
    return `${base}?pid=?pid=${pid}&c=${campaign}`;
}

export function getAmpUrl(url: string) {
    return `/the-buzz/amp/${url}`;
}

export const actionSignInUrl = 'https://badoo.com/?pid=badoo-ins-and-out';
export const downloadUrl = 'https://badoo.com/?pid=badoo-ins-and-out';

export const formAction = '/get-app';

export const rt = '212c2f';

export const inputPhoneProps = {
    countryCode: '44',
    countryName: 'gb',
    options: [
        {
            countryId: 'au',
            countryName: 'Australia',
            countryCode: '61',
        },
        {
            countryId: 'br',
            countryName: 'Brazil',
            countryCode: '55',
        },
        {
            countryId: 'ca',
            countryName: 'Canada',
            countryCode: '1',
        },
        {
            countryId: 'cn',
            countryName: 'China',
            countryCode: '86',
        },
        {
            countryId: 'cn',
            countryName: 'China',
            countryCode: '853',
        },
        {
            countryId: 'dk',
            countryName: 'Denmark',
            countryCode: '45',
        },
        {
            countryId: 'fi',
            countryName: 'Finland',
            countryCode: '358',
        },
        {
            countryId: 'fr',
            countryName: 'France',
            countryCode: '33',
        },
        {
            countryId: 'de',
            countryName: 'Germany',
            countryCode: '49',
        },
        {
            countryId: 'in',
            countryName: 'India',
            countryCode: '91',
        },
        {
            countryId: 'ie',
            countryName: 'Ireland',
            countryCode: '353',
        },
        {
            countryId: 'it',
            countryName: 'Italy',
            countryCode: '39',
        },
        {
            countryId: 'jp',
            countryName: 'Japan',
            countryCode: '81',
        },
        {
            countryId: 'mx',
            countryName: 'Mexico',
            countryCode: '52',
        },
        {
            countryId: 'nl',
            countryName: 'Netherlands',
            countryCode: '31',
        },
        {
            countryId: 'nz',
            countryName: 'New Zealand',
            countryCode: '64',
        },
        {
            countryId: 'no',
            countryName: 'Norway',
            countryCode: '47',
        },
        {
            countryId: 'ph',
            countryName: 'Philippines',
            countryCode: '63',
        },
        {
            countryId: 'pl',
            countryName: 'Poland',
            countryCode: '48',
        },
        {
            countryId: 'pt',
            countryName: 'Portugal',
            countryCode: '351',
        },
        {
            countryId: 'ru',
            countryName: 'Russia',
            countryCode: '7',
        },
        {
            countryId: 'sg',
            countryName: 'Singapore',
            countryCode: '65',
        },
        {
            countryId: 'za',
            countryName: 'South Africa',
            countryCode: '27',
        },
        {
            countryId: 'kr',
            countryName: 'South Korea',
            countryCode: '82',
        },
        {
            countryId: 'es',
            countryName: 'Spain',
            countryCode: '34',
        },
        {
            countryId: 'se',
            countryName: 'Sweden',
            countryCode: '46',
        },
        {
            countryId: 'ae',
            countryName: 'United Arab Emirates',
            countryCode: '971',
        },
        {
            countryId: 'gb',
            countryName: 'United Kingdom',
            countryCode: '44',
        },
        {
            countryId: 'us',
            countryName: 'United States',
            countryCode: '1',
        },
    ],
};

export const captchaProps = {
    src: 'https://bumble.com/reg_code.phtml?rt=212c2f&amp;rand=55424&amp;place=28',
};

export function getImageFromPost(post: Post) {
    return post.featuredImage?.node?.sourceUrl || null;
}

export function getImageDimensionsFromPost(post: Post) {
    return {
        postImageWidth: post.featuredImage?.node?.mediaDetails?.width || 'auto',
        postImageHeight: post.featuredImage?.node?.mediaDetails?.height || 'auto',
    };
}

export function getEmbedInstagramPostFromPostId(postId: string) {
    return `<blockquote class="instagram-media" data-instgrm-captioned data-instgrm-permalink="https://www.instagram.com/p/${postId}/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="12" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="https://www.instagram.com/p/${postId}/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;"> View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div></a></div></blockquote> <script async src="//www.instagram.com/embed.js"></script>`;
}

export function getInstagramLinksFromContent(content: string) {
    // if 2 identical urls will be received - it will return one
    const match = content.match(
        // eslint-disable-next-line no-empty-character-class
        /<figure class="wp-block-embed-instagram[\W\w\S\s]+?">[\W\w\S\s]+?https:\/\/www\.instagram.com\/p\/(.+)\/[\W\w\S\s]+?<\/figure>/gm
    );
    let result;

    if (match) {
        result = match.map((item: string) => {
            const id = item?.match(/https:\/\/www\.instagram.com\/p\/(.+?)\//g);

            return {
                url: item,
                // @ts-ignore
                id: id[0]?.replace('https://www.instagram.com/p', '')?.replace(/\//g, ''),
            };
        });
    }

    return result;
}

export function getIYoutubeLinksFromContent(content: string) {
    // if 2 identical urls will be received - it will return one
    const match = content.match(/\nhttps:\/\/www\.youtube\.com\/watch\?v=(.+)\n/g);
    let result;

    if (match) {
        result = match.map((item: string) => {
            return {
                url: item,
                id: item.replace('https://www.youtube.com/watch?v=', '').replace(/\n/g, ''),
            };
        });
    }

    return result;
}

export function getEmbedYoutubePostFromPostId(postId: string) {
    return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${postId}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
}

export function getEmbedAmpInstagramPostFromPostId(id?: string) {
    return id
        ? `
    <amp-instagram
        data-shortcode="${id}"
        data-captioned
        width="400"
        height="400"
        layout="responsive"
    >
    </amp-instagram>
    `
        : '';
}

export function getEmbedAmpYoutubePostFromPostId(id?: string) {
    const src = id?.replace(/https:\/\/www.youtube.com\/watch?v=(.+?)$/, '$1');

    return `
        <amp-youtube
            data-videoid="${src}"
            layout="responsive"
            width="480"
            height="270"
        ></amp-youtube>
    `;
}

export function getAmpVideoFromId(id?: string) {
    return `
        <amp-video controls
            width="640"
            height="360"
            layout="responsive"
        >
            <source
                src="${id}"
                type="video/mp4"
            />
            <div fallback>
                <p>This browser does not support the video element.</p>
            </div>
        </amp-video>
    `;
}

export function getAmpIframeFromSrc(src?: string) {
    return `
        <div class="wp-amp-iframe">
            <amp-iframe
                width="200"
                height="100"
                sandbox="allow-scripts allow-same-origin"
                layout="responsive"
                frameborder="0"
                src="${src}"
            >
            </amp-iframe>
        </div>
    `;
}

export function getSocialMediaImageFromPost(post: Post) {
    let image = SOCIAL_IMAGE_FALLBACK;

    const imageObject = post.featuredImage?.node?.mediaDetails?.sizes
        ?.filter((item) => {
            const width = item?.width ? parseInt(item?.width, 10) : 0;
            const height = item?.height ? parseInt(item?.height, 10) : 0;

            return width < 1400 && height < 1400;
        })
        .sort((imageSize1, imageSize2) => {
            const widthA = imageSize1?.width ? parseInt(imageSize1?.width, 10) : 0;
            const widthB = imageSize2?.width ? parseInt(imageSize2?.width, 10) : 0;

            return widthA - widthB;
        })
        .pop();

    if (imageObject && typeof imageObject?.sourceUrl === 'string') {
        image = imageObject?.sourceUrl;
    }

    // Converts an image source to a dynamic next image if it's an internal cdn url
    if (image.startsWith('http://cdn-internal:8081/')) {
        return image.replace('http://cdn-internal:8081/', 'https://bumble.com/the-buzz/cdn-image/');
    }

    return image;
}

export const BUMBLE_DOMAIN = 'https://bumble.com/';

export const APPSFLYER_LINKS = {
    CAMPAIGNS: {
        NIGHT_IN_TEASER: {
            APP_STORE: 'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeTeaser',
            GOOGLE_PLAY:
                'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeTeaser',
        },
        NIGHT_IN: {
            APP_STORE: 'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeUS',
            GOOGLE_PLAY: 'https://bumble.onelink.me/3396940749?pid=campaign&c=NightInMicrositeUS',
        },
        SAFETY_CENTER: {
            APP_STORE: 'https://bumble.onelink.me/3396940749?pid=campaign&c=safetycentermicrosite',
            GOOGLE_PLAY:
                'https://bumble.onelink.me/3396940749?pid=campaign&c=safetycentermicrosite',
        },
    },
};

export const BFF_HELP_CENTER_LINKS = {
    // INDEX: 'https://support.bumbleforfriends.com/hc',
    INDEX: 'https://bumble.com/help',
};

export const BFF_MENU_LINKS = {
    PRIVACY: 'https://bumble.com/bff/privacy',
    TERMS: 'https://bumble.com/bff/terms',
    GUIDELINES: 'https://bumble.com/bff/guidelines',
};
